import React, { Component } from 'react';
import './Admin.css';
import { withAuth } from "../Auth/WithAuth";
import { authenticatedFetch } from "../../utils/apiClient";


//A modal for adding a user from admin


export default withAuth(
  class AddUserModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
          firstName: "",
          lastName: "",
          email: "",
          age: "",
          phone: "",
          foodTicket: false,
          paid: false,
          arrived: false,
          rowNum: "",
          seatNum: "",
          special: "",
          error: "",
          isSubmitting: false
        }

        this.handleSave = this.handleSave.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
        this.closeModal = this.closeModal.bind(this);
      }


      handleInputChange(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value, error: "" });
      }

      handleCheckboxChange(e) {
        const { name, checked } = e.target;
        this.setState({ [name]: checked });
      }

      closeModal(clearForm = true) {
        if (clearForm) {
          this.setState({
            firstName: "",
            lastName: "",
            email: "",
            age: "",
            phone: "",
            foodTicket: false,
            paid: false,
            arrived: false,
            rowNum: "",
            seatNum: "",
            special: "",
            error: "",
            isSubmitting: false
          });
        } else {
          this.setState({
            error: "",
            isSubmitting: false
          });
        }
        this.props.addUser();
      }

      handleBackdropClick = (e) => {
        if (e.target === e.currentTarget) {
          this.closeModal(false); // Don't clear form on backdrop click
        }
      }

      async generateUserCode() {
        let code;
        let isUnique = false;
        
        while (!isUnique) {
          // Generate a random 6-character code
          code = Math.random().toString(36).substring(2, 8).toUpperCase();
          
          try {
            // Check if code already exists as a booking code in database
            const response = await authenticatedFetch(`/api/admin/checkBookingCode/${code}`, {
              method: "GET"
            });
            
            if (response.ok) {
              const result = await response.json();
              isUnique = !result.exists; // If booking code doesn't exist, it's unique
            } else {
              // If there's an error checking, generate a new code and try again
              continue;
            }
          } catch (err) {
            // On network error, try again
            console.error("Error checking booking code:", err);
            continue;
          }
        }
        
        return code;
      }

      async handleSave() {
        const { firstName, lastName, email, age, phone, rowNum, seatNum, special, foodTicket, paid, arrived } = this.state;

        // Validation
        if (!firstName || !lastName || !email || !age || !phone || !rowNum || !seatNum) {
          this.setState({ error: "Alle påkrevde felt må fylles ut" });
          return;
        }

        if (isNaN(age) || age < 1 || age > 150) {
          this.setState({ error: "Ugyldig alder" });
          return;
        }

        if (isNaN(rowNum) || isNaN(seatNum) || rowNum < 1 || seatNum < 1) {
          this.setState({ error: "Ugyldig rad eller plass nummer" });
          return;
        }

        this.setState({ isSubmitting: true });

        try {
          const updatedBy = this.props.auth.currentUser ? this.props.auth.currentUser.username : "Admin";
          const code = await this.generateUserCode();

          const userData = {
            code: code,
            firstName: firstName.trim(),
            lastName: lastName.trim(),
            email: email.trim(),
            age: parseInt(age, 10),
            phone: phone.trim(),
            rowNum: parseInt(rowNum, 10),
            seatNum: parseInt(seatNum, 10),
            special: special.trim(),
            foodTicket: foodTicket,
            paid: paid,
            arrived: arrived,
            timestamp: Date.now(),
            UpdatedBy: updatedBy
          };

          const response = await authenticatedFetch("/api/admin/adduser", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify(userData)
          });

          if (response.ok) {
            this.props.onUserAdded(); // Refresh the user list
            this.closeModal();
          } else {
            const errorData = await response.json();
            this.setState({ 
              error: errorData.error || "Feil ved opprettelse av bruker. Sjekk at plassen er ledig.",
              isSubmitting: false 
            });
          }
        } catch (err) {
          console.error("Error adding user:", err);
          this.setState({ 
            error: "Nettverksfeil ved opprettelse av bruker",
            isSubmitting: false 
          });
        }
      }




render() {
    const { error, isSubmitting } = this.state;
    
    return (
      <div className="Modal" onClick={this.handleBackdropClick} style={{
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000
      }}>
        <div className="card" style={{
          maxWidth: '500px', 
          padding:'16px',
          margin: '0 auto',
          backgroundColor: '#343a40',
          color: 'white',
          border: '1px solid #6c757d'
        }}>
          <h3 style={{marginBottom: '20px', textAlign: 'center'}}>Legg til bruker</h3>
          
          {error && (
            <div className="alert alert-danger" role="alert" style={{fontSize: '14px', padding: '8px 12px'}}>
              {error}
            </div>
          )}
          
          <div className="row">
            <div className="col-6">
              <label style={{fontSize: '13px', fontWeight: 'bold'}}>Fornavn *</label>
              <input 
                type="text" 
                name="firstName" 
                value={this.state.firstName} 
                onChange={this.handleInputChange} 
                className="form-control form-control-sm"
                disabled={isSubmitting}
              />
            </div>
            <div className="col-6">
              <label style={{fontSize: '13px', fontWeight: 'bold'}}>Etternavn *</label>
              <input 
                type="text" 
                name="lastName" 
                value={this.state.lastName} 
                onChange={this.handleInputChange} 
                className="form-control form-control-sm"
                disabled={isSubmitting}
              />
            </div>
          </div>
          
          <div style={{marginTop: '12px'}}>
            <label style={{fontSize: '13px', fontWeight: 'bold'}}>E-post *</label>
            <input 
              type="email" 
              name="email" 
              value={this.state.email} 
              onChange={this.handleInputChange} 
              className="form-control form-control-sm"
              disabled={isSubmitting}
            />
          </div>
          
          <div className="row" style={{marginTop: '12px'}}>
            <div className="col-4">
              <label style={{fontSize: '13px', fontWeight: 'bold'}}>Alder *</label>
              <input 
                type="number" 
                name="age" 
                value={this.state.age} 
                onChange={this.handleInputChange} 
                className="form-control form-control-sm"
                disabled={isSubmitting}
              />
            </div>
            <div className="col-8">
              <label style={{fontSize: '13px', fontWeight: 'bold'}}>Telefon *</label>
              <input 
                type="text" 
                name="phone" 
                value={this.state.phone} 
                onChange={this.handleInputChange} 
                className="form-control form-control-sm"
                disabled={isSubmitting}
              />
            </div>
          </div>
          
          <div className="row" style={{marginTop: '12px'}}>
            <div className="col-6">
              <label style={{fontSize: '13px', fontWeight: 'bold'}}>Rad *</label>
              <input 
                type="number" 
                name="rowNum" 
                value={this.state.rowNum} 
                onChange={this.handleInputChange} 
                className="form-control form-control-sm"
                disabled={isSubmitting}
              />
            </div>
            <div className="col-6">
              <label style={{fontSize: '13px', fontWeight: 'bold'}}>Plass *</label>
              <input 
                type="number" 
                name="seatNum" 
                value={this.state.seatNum} 
                onChange={this.handleInputChange} 
                className="form-control form-control-sm"
                disabled={isSubmitting}
              />
            </div>
          </div>
          
          <div style={{marginTop: '12px'}}>
            <label style={{fontSize: '13px', fontWeight: 'bold'}}>Merknad</label>
            <textarea 
            style={{width:'100%'}}
              name="special" 
              value={this.state.special} 
              onChange={this.handleInputChange} 
              className="form-control form-control-sm"
              rows="2"
              disabled={isSubmitting}
            />
          </div>
          
          <div className="row" style={{marginTop: '15px', fontSize: '14px'}}>
            <div className="col-4">
              <div className="form-check">
                <input 
                  type="checkbox" 
                  name="foodTicket" 
                  checked={this.state.foodTicket} 
                  onChange={this.handleCheckboxChange}
                  className="form-check-input"
                  disabled={isSubmitting}
                />
                <label className="form-check-label">Mat</label>
              </div>
            </div>
            <div className="col-4">
              <div className="form-check">
                <input 
                  type="checkbox" 
                  name="paid" 
                  checked={this.state.paid} 
                  onChange={this.handleCheckboxChange}
                  className="form-check-input"
                  disabled={isSubmitting}
                />
                <label className="form-check-label">Betalt</label>
              </div>
            </div>
            <div className="col-4">
              <div className="form-check">
                <input 
                  type="checkbox" 
                  name="arrived" 
                  checked={this.state.arrived} 
                  onChange={this.handleCheckboxChange}
                  className="form-check-input"
                  disabled={isSubmitting}
                />
                <label className="form-check-label">Ankommet</label>
              </div>
            </div>
          </div>
          
          <div style={{marginTop: '20px', textAlign: 'center'}}>
            <button 
              className="btn btn-warning btn-sm" 
              onClick={() => this.closeModal(true)}
              disabled={isSubmitting}
              style={{marginRight: '10px', minWidth: '80px', cursor:'pointer'}}
            >
              Avbryt
            </button>
            <button 
              className="btn btn-info btn-sm" 
              onClick={this.handleSave}
              disabled={isSubmitting}
              style={{minWidth: '80px', cursor:'pointer'}}
            >
              {isSubmitting ? "Lagrer..." : "Lagre"}
            </button>
          </div>
        </div>
      </div>
    );
  }

}
);



// WEBPACK FOOTER //
// ./src/Components/Admin/AddUserModal.js